import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import React from 'react'
import type { PresentationSectionProps } from '../../../..'
import PageHeader from '../_components/PageHeader'

const useStyles = makeStyles<Theme, ColorHelpProps>(
  (theme) => ({
    root: {
      background: theme.palette.common.white,
      boxShadow:
        '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
      overflow: 'hidden'
    }
  }),
  { name: 'ColorHelp' }
)

export interface ColorHelpProps {
  classes?: StyleClasses<typeof useStyles>
}

function ColorHelp(props: PresentationSectionProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <PageHeader
        title={
          <>
            Get Help
            <br />
            With Color
          </>
        }
        ctaLabel="Order Samples"
        ctaLink="https://samples.sherwin-williams.com/?utm_medium=referral&utm_source=paintscout&utm_campaign=digall-2026&utm_content=samples-color-chips"
        backgroundImage={'https://paintscout.s3.us-east-1.amazonaws.com/partners/sw/images/header-background-img.png'}
        headerBackgroundColor="#1B6374"
      />
    </div>
  )
}

export default ColorHelp
